import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import { Badge, Collapse } from "@material-ui/core";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/QuestionAnswerOutlined";
import ViewColumnOutlinedIcon from "@material-ui/icons/ViewColumnOutlined";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import EventNoteIcon from "@material-ui/icons/EventNote";
import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
import HistoryIcon from "@material-ui/icons/History";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import BuildOutlinedIcon from "@material-ui/icons/BuildOutlined";
import AdminPanelSettingsOutlinedIcon from "@material-ui/icons/SecurityOutlined";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import EmojiObjectsOutlinedIcon from "@material-ui/icons/EmojiObjectsOutlined";

import { i18n } from "../translate/i18n";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { Can } from "../components/Can";
import api from "../services/api";

function ListItemLink(props) {
  const { icon, primary, to, className, onNavigate, nested } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  return (
    <li>
      <ListItem button component={renderLink} className={className} onClick={onNavigate} style={nested ? { paddingLeft: 32 } : undefined}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  );
}

const MainListItems = (props) => {
  const { drawerClose, drawerOpen } = props;
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user } = useContext(AuthContext);
  const [connectionWarning, setConnectionWarning] = useState(false);
  const [overdueFollowUps, setOverdueFollowUps] = useState(0);
  const [internalUnread, setInternalUnread] = useState(0);
  const [operationsOpen, setOperationsOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);

  useEffect(() => {
    const load = () => api.get("/operations-dashboard").then(({ data }) => setOverdueFollowUps(data.followUps.overdue || 0)).catch(() => {});
    load(); const timer = setInterval(load, 60000); return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const load = () => api.get("/internal-chats").then(({ data }) => setInternalUnread(data.reduce((sum, chat) => sum + Number(chat.unread || 0), 0))).catch(() => {});
    load(); const timer = setInterval(load, 30000); return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  return (
    <div>
      <ListItemLink
        to="/"
        primary="Dashboard"
        icon={<DashboardOutlinedIcon />}
        onNavigate={drawerClose}
      />
      <ListItemLink
        to="/alphagraf"
        primary="Painel AlphaGRAF"
        icon={<DashboardOutlinedIcon style={{ color: '#00D1FF' }} />}
        onNavigate={drawerClose}
      />
      <ListItemLink
        to="/tickets"
        primary={i18n.t("mainDrawer.listItems.tickets")}
        icon={<WhatsAppIcon />}
        onNavigate={drawerClose}
      />
      <ListItemLink
        to="/broadcast"
        primary="Disparador & Áudios"
        icon={<DynamicFeedIcon style={{ color: '#10b981' }} />}
        onNavigate={drawerClose}
      />

      <ListItemLink
        to="/kanban"
        primary={i18n.t("mainDrawer.listItems.kanban")}
        icon={<ViewColumnOutlinedIcon />}
        onNavigate={drawerClose}
      />
      <ListItemLink to="/internal-chat" primary="Chat interno" icon={<Badge badgeContent={internalUnread} color="secondary"><ForumOutlinedIcon /></Badge>} onNavigate={drawerClose} />
      <ListItemLink
        to="/follow-ups"
        primary="Agenda de retornos"
        icon={<Badge badgeContent={overdueFollowUps} color="secondary"><EventNoteIcon /></Badge>}
        onNavigate={drawerClose}
      />
      {drawerOpen && <>
        <Divider />
        <ListItem button onClick={() => setOperationsOpen(value => !value)}>
          <ListItemIcon><BuildOutlinedIcon /></ListItemIcon><ListItemText primary="Operações" />{operationsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </ListItem>
        <Collapse in={operationsOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemLink nested to="/contacts" primary={i18n.t("mainDrawer.listItems.contacts")} icon={<ContactPhoneOutlinedIcon />} onNavigate={drawerClose} />
            <ListItemLink nested to="/broadcast" primary="Disparador Anti-Ban" icon={<DynamicFeedIcon style={{ color: '#10b981' }} />} onNavigate={drawerClose} />
            <ListItemLink nested to="/quickAnswers" primary={i18n.t("mainDrawer.listItems.quickAnswers")} icon={<QuestionAnswerOutlinedIcon />} onNavigate={drawerClose} />
            <ListItemLink nested to="/attendance" primary="Bate-ponto" icon={<AccessTimeIcon />} onNavigate={drawerClose} />
          </List>
        </Collapse>
      </>}
      <Can
        role={user.profile}
        perform="drawer-admin-items:view"
        yes={() => (
          drawerOpen ? <>
            <ListItem button onClick={() => setAdminOpen(value => !value)}>
              <ListItemIcon><AdminPanelSettingsOutlinedIcon /></ListItemIcon><ListItemText primary="Administração" />{adminOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            <Collapse in={adminOpen} timeout="auto" unmountOnExit><List component="div" disablePadding>
            <ListItemLink
              nested
              to="/users"
              primary={i18n.t("mainDrawer.listItems.users")}
              icon={<PeopleAltOutlinedIcon />}
              onNavigate={drawerClose}
            />
            <ListItemLink
              nested
              to="/queues"
              primary={i18n.t("mainDrawer.listItems.queues")}
              icon={<AccountTreeOutlinedIcon />}
              onNavigate={drawerClose}
            />
            <ListItemLink nested to="/solution-leads" primary="Leads Soluções" icon={<EmojiObjectsOutlinedIcon />} onNavigate={drawerClose} />
            <ListItemLink
              nested
              to="/tags"
              primary={i18n.t("mainDrawer.listItems.tags")}
              icon={<LabelOutlinedIcon />}
              onNavigate={drawerClose}
            />
            <ListItemLink
              nested
              to="/ticket-custom-fields"
              primary="Campos personalizados"
              icon={<DynamicFeedIcon />}
              onNavigate={drawerClose}
            />
            <ListItemLink
              nested
              to="/audit-logs"
              primary="Auditoria"
              icon={<HistoryIcon />}
              onNavigate={drawerClose}
            />
            <ListItemLink
              nested
              to="/automation-rules"
              primary="Automações"
              icon={<FlashOnIcon />}
              onNavigate={drawerClose}
            />
            <ListItemLink nested to="/connections" primary={i18n.t("mainDrawer.listItems.connections")} icon={<Badge badgeContent={connectionWarning ? "!" : 0} color="error"><SyncAltIcon /></Badge>} onNavigate={drawerClose} />
            <ListItemLink
              nested
              to="/settings"
              primary={i18n.t("mainDrawer.listItems.settings")}
              icon={<SettingsOutlinedIcon />}
              onNavigate={drawerClose}
            />
            </List></Collapse>
          </> : null
        )}
      />
    </div>
  );
};

export default MainListItems;
